import { HOUR_FORMAT } from "../utils/constants";
import { getMonth } from '../utils/formatData'
import { dayjs } from "./Date/DateUtil";

export default function renderRawDate(rawDate: any, year?: boolean, lastupdated?: boolean) {
    var fulldate = rawDate ? rawDate : "";

    var split_date = fulldate?.split("T")[0]
    var split_time = fulldate?.split("T")[1]?.split(":")
    var split_year = split_date?.split("-")[0]

    var last_updated_hour = parseInt(split_time[0]) < 12 ? parseInt(split_time[0]): hour_format(split_time[0]) 
    var last_updted_minute = split_time[1]
    var last_updted_meridies =  split_time[0] >= 12 ? "pm" : "am"

    var get_month = getMonth(parseInt(split_date?.split("-")[1])-1) // return month name
    var get_day = split_date?.split("-")[2]
    var get_year = split_year

    var str_date = `day ${get_month} ${get_day} ${get_year}` // return `Sat Oct 31 2021` format

    var return_date = str_date?.split(" ")[1] + " " + str_date?.split(" ")[2]
    var return_date_year = str_date?.split(" ")[1] + " " + str_date?.split(" ")[2] + ", " + split_year
    var last_updated = return_date_year+" "+last_updated_hour+":"+last_updted_minute+" "+last_updted_meridies
    
    return lastupdated ? last_updated : year ? return_date_year : return_date
}

/**
 * @param params 
 * For converting 24 hour format to 12 hour format
 * @returns 
 */

function hour_format(params: any) {
    return parseInt(params) === HOUR_FORMAT ? HOUR_FORMAT : Math.abs(HOUR_FORMAT - parseInt(params))   
}

export const dateWithCurrentTimezone = (date: any) => date ? dayjs(date).format("MMM DD,YYYY hh:mm a") : ""
